export const EMPTY_TABLE_MESSAGE = Object.freeze({
  NO_LOCATIONS: 'No future notifications found.',
  NO_RESULTS: 'No results match the search criteria.'
})
